import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Footer from '../components/Footer';
import Header from '../components/Header';
import RecipeCard from '../components/RecipeCard';
import { fetchListArea, fetchFoodsAreaName, fetchAPIFood } from '../helpers/index';

function ExploreByArea() {
  const [foods, setFoods] = useState([]);
  const [apiListFood, setApiListFood] = useState([]);
  const [country, setCountry] = useState('');

  const getApiCategoriesFood = async () => {
    setApiListFood(await fetchListArea());
    setFoods(await fetchAPIFood());
  };

  const getFoodsArea = async () => {
    if (country === 'all' || !country) {
      setFoods(await fetchAPIFood());
    } else {
      setFoods(await fetchFoodsAreaName(country));
    }
  };

  useEffect(() => {
    getApiCategoriesFood();
  }, []);

  useEffect(() => {
    getFoodsArea();
  }, [country]);

  const zero = 0;
  const maxMeals = 12;

  return (
    <div className="page-wrapper-custom">
      <Header />
      <Container>
        {apiListFood !== undefined && apiListFood !== null && (
          <div className="my-4 d-flex justify-content-center">
            <div className="search-bar-card w-100" style={{ maxWidth: '400px' }}>
              <label htmlFor="explore-by-area-dropdown" className="fw-bold mb-2">
                🌍 Selecione a origem da culinária:
              </label>
              <select
                id="explore-by-area-dropdown"
                data-testid="explore-by-area-dropdown"
                value={ country }
                onChange={ (e) => setCountry(e.target.value) }
                className="search-bar-input w-100 form-select"
              >
                <option key="all" value="all" data-testid="All-option">✨ Todas as regiões</option>
                {apiListFood
                  .map((item) => (
                    <option
                      key={ item.strArea }
                      value={ item.strArea }
                      data-testid={ `${item.strArea}-option` }
                    >
                      {item.strArea}
                    </option>))}
              </select>
            </div>
          </div>
        )}

        <div className="recipes-grid-custom mt-4">
          {foods !== undefined && foods !== null ? (
            foods.slice(zero, maxMeals).map((item, index) => (
              <Link
                className="recipe-link"
                to={ `/comidas/${item.idMeal}` }
                key={ item.strMeal || index }
              >
                <RecipeCard
                  idRecipeCard={ `${index}-recipe-card` }
                  idImg={ `${index}-card-img` }
                  srcImg={ item.strMealThumb }
                  idCardName={ `${index}-card-name` }
                  mealName={ item.strMeal }
                />
              </Link>
            ))
          ) : []}
        </div>
      </Container>
      <Footer className="footer orange" />
    </div>
  );
}

export default ExploreByArea;
